export * from './qa';
export * from './number';

export const isNullish = (prop: any) => prop === null || prop === undefined;
export const pluralise = (msg: string, amount: number, suffix = 's') =>
  amount > 1 ? `${msg}${suffix}` : msg;
